
































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class RadioBox extends Vue {
  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public nativeValue!: any;

  @Prop({ default: null })
  public title!: string;

  @Prop({ default: null })
  public desc!: string;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: false })
  public withoutTick!: boolean;

  @Prop({ default: null })
  public icon!: string;

  @Prop({ default: false })
  public deselect!: boolean;

  @Prop({ default: true })
  public hasRadio!: boolean;

  @Prop({ default: "fas" })
  public pack!: string;

  public get isDisabled() {
    return this.disabled;
  }

  public get isActive() {
    return !this.$_.isNull(this.value) && this.nativeValue === this.value;
  }

  public onClick(value: any) {
    if (!this.disabled) {
      this.$emit(
        "input",
        value === this.value ? (this.deselect ? null : value) : value
      );
    }
  }
}
